export function delay(ms: number, action: (() => void)) {

    function delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    return new Promise(resolve => (async () => {
        await delay(ms);
        action()
        resolve()
    })())

}
